import { render } from "./EnPrivacyView.vue?vue&type=template&id=36783d36&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./EnPrivacyView.vue?vue&type=script&lang=js"
export * from "./EnPrivacyView.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/en/Privacy.css?vue&type=style&index=1&id=36783d36&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36783d36"]])

export default __exports__